import { PageProps } from 'gatsby';
import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { TrainersListview } from '../features/trainers-listview';

const Trainers:React.FC<PageProps> = ({location}) => {
  return (
    <Layout>
      <SEO
        location={location}
        keywords={[
          `find best trainer`,
          `customization`,
          `trainers list`,
          `price list trainers`,
          `cheap trainers`,
          `affordable`,
          `coach`,
          `available spots`,
        ]}
        title="Trainers"
        description="Find Your Personal Trainer"
      />
      <TrainersListview />
    </Layout>
  );
}

export default Trainers;
